import { Spinner } from 'evergreen-ui'
import React, { FC } from 'react'
import ReactPlayer from 'react-player'
import { PodcastEpisode } from '../../data/podcasts'
import styles from './PodcastPlayer.module.scss'

interface PodcastPlayerProps {
  episode: PodcastEpisode
}

// Same HLS player configuration the Therapeutic Needling videos use.
const PodcastPlayer: FC<PodcastPlayerProps> = ({ episode }) => {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

  return (
    <div className={styles.playerWrapper} data-testid="PodcastPlayer">
      <ReactPlayer
        url={episode.videoUrl}
        light={episode.thumbnailUrl}
        playing={true}
        controls={true}
        playsinline={true}
        width="100%"
        height="100%"
        fallback={<Spinner />}
        config={{
          file: {
            forceHLS: !isSafari,
            forceVideo: true,
            attributes: { poster: episode.thumbnailUrl },
            hlsOptions: {
              xhrSetup: function (xhr: any) {
                xhr.withCredentials = true
              },
            },
          },
        }}
      />
    </div>
  )
}

export default PodcastPlayer
